import { useState } from "react";
import axios from "axios";
import { ToastBottomEnd } from "views/components/Toast";
import { toastAddErrorMessageConfig } from "config/toastConfig";
import appConfig from "config/appConfig";
import { ConfirmIaDataCollect } from "views/components/ConfirmationAlert";
import { confirmIaDataConfig } from "config/confirmConfig";

export const useIaDataToggle = (config, onConfigUpdate) => {
  const [isToggling, setIsToggling] = useState(false);

  const handleToggle = async () => {
    setIsToggling(true);

    try {
      const confirmMessage = config.actived
        ? "Voulez vous vraiment désactiver cette fonctionnalité ?"
        : "Voulez vous vraiment activer cette fonctionnalité ?";

      const result = await ConfirmIaDataCollect.fire(
        confirmIaDataConfig(confirmMessage)
      );

      if (result.isConfirmed) {
        await activateFeature(config, onConfigUpdate);
      } else {
        await deactivateFeature(config, onConfigUpdate);
      }
    } catch (error) {
      ToastBottomEnd.fire(toastAddErrorMessageConfig("L'action a échouée"));
    } finally {
      setIsToggling(false);
    }
  };

  return {
    isToggling,
    handleToggle,
  };
};

const activateFeature = async (config, onConfigUpdate) => {
  let apiKey = config.api_key;

  if (!apiKey) {
    const registerResponse = await axios.post(
      "http://212.83.146.159:5550/api/v1/dash/register",
      {
        name: config.name,
        query: config.query,
        url: window.location.hostname,
      },
      {
        headers: {
          Authorization: null,
        },
      }
    );
    apiKey = registerResponse.data?.data?.token;
  }

  await axios.put(
    `${appConfig.apiDomaine}/configurations/satisfaction-data-config`,
    {
      actived: 1,
      api_key: apiKey,
    }
  );

  onConfigUpdate({
    ...config,
    actived: 1,
    api_key: apiKey,
  });
};

const deactivateFeature = async (config, onConfigUpdate) => {
  await axios.put(
    `${appConfig.apiDomaine}/configurations/satisfaction-data-config`,
    {
      actived: 0,
      api_key: config.api_key,
    }
  );

  onConfigUpdate({
    ...config,
    actived: 0,
  });
};
